const keys = {
  electricalDetails: {
    amperage: {
      choices: {
        amperage100A: '100A',
        amperage200A: '200A',
        amperage60A: '60A',
      },
    },
    panelType: {
      choices: {
        breakers: 'Breakers',
        fuses: 'Fuses',
      },
      helper: {
        cells: {
          breakers: {
            description:
              'A breaker protects electrical circuit by tripping in case of an electricity overload. Breakers looks generally like a small box with a switch. It is mostly found in new buildings.',
            title: 'Breakers',
          },
          fuses: {
            description:
              'A fuse protects electrical circuits by melting in case of an electricity overload. There are many types of fuses: cylinder, tube, bolt etc. It is mostly found in older buildings.',
            title: 'Fuses',
          },
        },
        title: 'What is your electrical panel type?',
      },
    },

    titles: {
      panelType: 'What is your electrical panel type?',
    },
  },
};

export default keys;

export type TranslationKeys = typeof keys;
